
window.xrayMode =
  window.location.href.indexOf('xray=1') > -1

$('html').addClass 'xray' if window.xrayMode && $?